import qs from 'qs'
import * as storage from '@/utils/storage'
import http from '../utils/http'
import config from '../config'

class UserModel {
  static baseUrl = config.baseUrl + '/user'
  static async login({ gameId, username, password, token = '', that }) {
    let info = {}
    if (token) {
      const { payload: loginInfo } = await http.get(
        `${UserModel.baseUrl}/login/${gameId}/${username}/${password}?token=${token}`
      )
      info = loginInfo
    } else if (storage.getItem('oid')) {
      let oid = storage.getItem('oid')
      let url = `${UserModel.baseUrl}/login/${gameId}/${username}/${password}?openid=${oid}`
      const { payload: loginInfo } = await http.get(url)
      info = loginInfo
    } else {
      const { payload: loginInfo } = await http.get(
        `${UserModel.baseUrl}/login/${gameId}/${username}/${password}`
      )
      info = loginInfo
    }
    let { gameData } = info
    if (gameData.COZE) {
      that.$root.COZEID = gameData.COZE
      storage.setItem('COZEID', gameData.COZE)
    }


    return info
  }

  static async registercheck(gameId) {
    const result = await http.get(
      `${UserModel.baseUrl}/registercheck/${gameId}`
    )
    return result
  }

  static async register({ gameId, username, password, email, teamname, tag }) {
    const { payload } = await http.post(
      `${UserModel.baseUrl}/register`,
      qs.stringify({ gameId, username, password, email, teamname, tag }),
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    )
    return payload.teamId
  }

  static async logout() {
    await http.get(`${UserModel.baseUrl}/logout`)
  }

  static async updateaName(teamId, teamName) {
    await http.get(`/admin/change/teamname/${teamId}/${teamName}`)
  }

  static async wxUserCheck(gameid, oid) {
    const data = await http.get(`${UserModel.baseUrl}/wxusercheck/${gameid}/${oid}`)
    return data
  }

  static async wxRegister(gameid, oid, name) {
    const data = await http.get(`${UserModel.baseUrl}/wxregister/${gameid}/${oid}/${name}`)
    return data
  }

  static async wxLogin(gameid, oid, that) {
    const { payload: loginInfo } = await http.get(`${UserModel.baseUrl}/wxlogin/${gameid}/${oid}`)
    let { gameData } = loginInfo
    if (gameData.COZE) {
      that.$root.COZEID = gameData.COZE
      storage.setItem('COZEID', gameData.COZE)
    }
    return loginInfo
  }
  static async forgetPassword({ username = '000', gameId, email }) {
    const data = await http.get(`${UserModel.baseUrl}/forgetPassword/${gameId}/${username}/${email}`)
    return data
  }
  static async passwordReset({ token, newPassword }) {
    const data = await http.post(`${UserModel.baseUrl}/passwordReset/${token}/${newPassword}`)
    return data
  }
  static async passwordChange({ oldPassword, newPassword }) {
    const data = await http.post(`${UserModel.baseUrl}/passwordChange/${oldPassword}/${newPassword}`)
    return data
  }

  static async insertTeam(token) {
    const data = await http.get(`${config.baseUrl}/groupevent/add/${token}`)
    return data
  }

  static async getTeam(token) {
    const data = await http.get(`${config.baseUrl}/groupevent/info/${token}`)
    return data
  }

  static async login1({ gid, tid }) {
    const data = await http.get(`/admin/team/entrytoken/${gid}/${tid}`)
    let { payload } = data
    return payload
  }

}

export default UserModel
